
























































import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useStore } from '@/components/composables/useStore';
import { Store } from 'vuex';
import { RootState } from '@/store/Store';
import { DropdownFilter, ICustomOption, IFieldFilter } from '@/models/filters/Filters';
import _ from 'lodash';
import { getEntityStorePath } from '@/store/entityModules/utils';
import { EntityType } from '@/store/entityModules/types';

interface State {
  value: number[];
  items: any[];
}

interface Props {
  filterDropdown: DropdownFilter;
  filterItems?: (items: any[]) => any[]; // client side filter after fetching. https://vuetifyjs.com/en/components/autocompletes/#filter does not work with current vuetify version
  onChange?: Function;
  clearable: boolean;
  multiple: boolean;
  filter: IFieldFilter;
  rules?: Array<(a: any) => boolean | string>;
  deletableChips?: boolean;
  placeholder?: string;
  required: boolean;
  customOption?: ICustomOption[];
  showCheckbox?: boolean;
}

const Component = defineComponent({
  name: 'PaginatedAutocomplete',

  props: {
    filterDropdown: Object,
    filterItems: Function,
    onChange: Function,
    clearable: Boolean,
    multiple: Boolean,
    filter: Object,
    rules: Array,
    deletableChips: Boolean,
    placeholder: String,
    required: Boolean,
    customOption: Array,
    showCheckbox: Boolean,
  },

  setup(props: Props) {
    const store: Store<RootState> = useStore();
    const items: any[] = [];
    const moduleName = props.filterDropdown.itemsModuleName;

    //initial value should be array if multiple===true
    store.dispatch(
      `${moduleName}/setCustomInitialValue`,
      props.filterDropdown.initialValue,
    );
    store.dispatch(`${moduleName}/setCustomFilterField`, props.filter);
    store.dispatch(`${moduleName}/fetchCustomFilteredItems`, {
      startFromPage: 1,
      customOptions: props.customOption,
    });

    //used to track if new data fetch from request
    let isAllItems: boolean = false;
    let allItems: any[];

    const state: State = reactive({
      value: props.filterDropdown.initialValue,
      items: computed(() => {
        const newItems = store.getters[`${moduleName}/customFilteredItems`];

        if (newItems?.length == 0 && allItems !== undefined) isAllItems = true;
        else if (allItems === undefined) allItems = [];

        if (newItems) allItems = [...allItems, ...newItems];

        if (props.filterItems) allItems = props.filterItems(allItems);
        return allItems;
      }),
      loading: computed(() => store.getters[`${moduleName}/customLoading`]),
    });

    const updateItemsList = _.debounce((event: any) => {
      const value = event?.target.value;
      if (value === '') store.dispatch(`${moduleName}/setCustomSearchField`, undefined);
      else
        store.dispatch(`${moduleName}/setCustomSearchField`, {
          headers: [props.filterDropdown.textPropName],
          value,
        });
      store.dispatch(`${moduleName}/fetchCustomFilteredItems`);
    }, 200);

    const endIntersect = _.debounce(
      (entries: any, observer: any, isIntersecting: any) => {
        if (isIntersecting && !isAllItems) {
          store.dispatch(`${moduleName}/setCustomFiltersNextPage`);
          store.dispatch(`${moduleName}/fetchCustomFilteredItems`);
        }
      },
      500,
    );

    const isCategoryModule =
      props.filterDropdown.itemsModuleName === getEntityStorePath(EntityType.CATEGORY);

    return {
      state,
      items,
      updateItemsList,
      endIntersect,
      isCategoryModule,
    };
  },
});

export default Component;
